import {
    ALOG_CHOOSE_CURRENT_ALOG,
} from './constants';
  
export function chooseCurrentAlog(modal) {
    return {
      type: ALOG_CHOOSE_CURRENT_ALOG,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case ALOG_CHOOSE_CURRENT_ALOG:
        return {
          ...state,
          currentAlog:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/alog/redux/chooseCurrentAlog.js